import RegionApplication from './RegionApplication';

export default {
  path: '/region-applications/:year',
  name: 'user.manage-region-application',
  component: RegionApplication,
};
